<template>
  <div class="base-switch"
       :class="switchClasses">
    <div class="wrapper">
      <div class="option"
           :class="{ 'selected': option.key === value.key }"
           v-for="option in options"
           :key="option.key"
           @click="$emit('change', option)">
        {{ option.value }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      options: {
        required: true,
        type: Array
      },

      value: {
        required: true,
        type: Object
      }
    },

    computed: {
      switchClasses() {
        return {
          'base-switch-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  $border-radius: 26px;

  .base-switch {
    width: 100%;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    .wrapper {
      display: flex;
      margin: 0 auto;
      font-size: 21px;
      background-color: #f2f2f2;
      border-radius: $border-radius;

      .option {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: 41px;
        color: rgba(#3e3a3b, .4);
        border-radius: $border-radius;
        cursor: pointer;
        transition: all .1s ease-out;
        user-select: none;

        &.selected {
          font-weight: bold;
          color: #343131;
          background-color: map.get($colors, secondary);
        }
      }
    }
  }

  .base-switch-mobile {
    .wrapper {
      .option {
        height: 30px;
      }
    }
  }
</style>
